import { useTranslation } from 'react-i18next';

import { Button } from '@/components/generic';
import { ButtonVariant } from '@/components/generic/Button/button-config';
import { ModalLayout } from '@/components/layouts';
import { DangerIcon } from '@/resources';

type DeviceScheduleInterruptionModalProps = {
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
  onClose: () => void;
  isLoading?: boolean;
};

export const DeviceScheduleInterruptionModal = ({
  isOpen,
  message,
  onConfirm,
  onClose,
  isLoading = false
}: DeviceScheduleInterruptionModalProps) => {
  const [t] = useTranslation('common');

  return (
    <ModalLayout isOpen={isOpen} onClose={onClose}>
      <div className='flex w-full max-w-md flex-col items-center gap-4 rounded-2xl bg-white pb-6'>
        <DangerIcon className='size-16' />
        <div className='text-center text-xl font-semibold text-primary-blue'>{t('nowPlaying')}</div>
        <div className='px-6 text-center text-secondary-gray'>{message}</div>
        <div className='h-px w-full bg-secondary-blue-gray' />
        <div className='flex w-full justify-between gap-5 px-6 pt-1'>
          <Button
            variant={ButtonVariant.SECONDARY}
            handleOnClick={onClose}
            className='w-full'
            disabled={isLoading}>
            {t('cancel')}
          </Button>
          <Button
            variant={ButtonVariant.PRIMARY}
            handleOnClick={onConfirm}
            className='w-full'
            disabled={isLoading}>
            {isLoading ? t('processing') : t('confirm')}
          </Button>
        </div>
      </div>
    </ModalLayout>
  );
};
